import {BaseTerms} from "../../infrastructure/models/base-terms";

export class TopPerformersWidgetTerms extends BaseTerms {
  WEB_GAME_LEADERS = "Game Leaders";
  WEB_SEASON_LEADERS = "Season Leaders";
  WEB_FULL_BOX_SCORE  = "See Full Box Score";
}
